<template>
  <div class="uv-root">

    <!-- Loading -->
    <div v-if="userData === null" class="uv-loading">
      <div class="uv-spinner"></div>
      <span>Carregando dados do usuário…</span>
    </div>

    <!-- Not Found -->
    <div v-else-if="userData === undefined" class="uv-not-found">
      <div class="uv-nf-icon">
        <svg width="56" height="56" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5"/><path d="M15 9l-6 6M9 9l6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
      </div>
      <h3>Usuário não encontrado</h3>
      <p>O usuário que você está procurando não existe ou foi removido.</p>
      <router-link :to="{ name: 'apps-usuarios-lista' }" class="uv-btn-back">← Voltar à lista</router-link>
    </div>

    <!-- Content -->
    <template v-if="userData">

      <!-- Breadcrumb / Back Nav -->
      <div class="uv-topbar">
        <router-link :to="{ name: 'apps-usuarios-lista' }" class="uv-back-link">
          <svg width="16" height="16" fill="none" viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
          Lista de usuários
        </router-link>
        <span class="uv-breadcrumb-sep">/</span>
        <span class="uv-breadcrumb-cur">{{ userData.fullName }}</span>
      </div>

      <!-- Main Grid -->
      <div class="uv-grid">

        <!-- Left: Info Card (large) -->
        <div class="uv-col-main">
          <user-view-user-info-card :user-data="userData" />
        </div>

        <!-- Right: Plan + Permissions -->
        <div class="uv-col-side">
          <user-view-user-plan-card :user-data="userData" />
          <user-view-user-permissions-card :user-data="userData" />
        </div>

      </div>

    </template>
  </div>
</template>

<script>
import store from '@/store'
import router from '@/router'
import { ref, onUnmounted } from '@vue/composition-api'
import userStoreModule from '@/views/App/Usuarios/userStoreModule'
import UserViewUserInfoCard from './UserViewUserInfoCard.vue'
import UserViewUserPlanCard from './UserViewUserPlanCard.vue'
import UserViewUserPermissionsCard from './UserViewUserPermissionsCard.vue'

export default {
  components: {
    UserViewUserInfoCard,
    UserViewUserPlanCard,
    UserViewUserPermissionsCard,
  },
  setup() {
    const userData = ref(null)
    const USER_APP_STORE_MODULE_NAME = 'app-user'
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) {
      store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule)
    }
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) {
        store.unregisterModule(USER_APP_STORE_MODULE_NAME)
      }
    })
    store.dispatch('app-user/fetchUser', { id: router.currentRoute.params.id })
      .then(response => { userData.value = response.data })
      .catch(() => { userData.value = undefined })
    return { userData }
  },
}
</script>

<style scoped>
.uv-root { padding: 0; }

/* ─── Loading ─── */
.uv-loading {
  display: flex; flex-direction: column; align-items: center;
  justify-content: center; padding: 80px 0; gap: 16px;
  color: var(--dk-text-muted, #8a94a6); font-size: 14px;
}
.uv-spinner {
  width: 40px; height: 40px; border-radius: 50%;
  border: 3px solid var(--dk-border-light, #f0f2f5); border-top-color: #E86A10;
  animation: uv-spin 0.7s linear infinite;
}
@keyframes uv-spin { to { transform: rotate(360deg); } }

/* ─── Not Found ─── */
.uv-not-found {
  text-align: center; padding: 80px 20px;
  max-width: 400px; margin: 0 auto;
}
.uv-nf-icon { color: var(--dk-text-faint, #dde1e8); margin-bottom: 20px; }
.uv-not-found h3 { color: var(--dk-text-primary, #0D3349); font-size: 20px; margin: 0 0 8px; }
.uv-not-found p { color: var(--dk-text-muted, #8a94a6); font-size: 14px; margin: 0 0 24px; }
.uv-btn-back {
  display: inline-flex; align-items: center; gap: 6px;
  background: #E86A10; color: #fff; border-radius: 10px;
  padding: 10px 20px; font-size: 14px; font-weight: 600;
  text-decoration: none; transition: background 0.15s;
}
.uv-btn-back:hover { background: #cf5e0d; }

/* ─── Topbar ─── */
.uv-topbar {
  display: flex; align-items: center; gap: 8px;
  margin-bottom: 20px;
}
.uv-back-link {
  display: inline-flex; align-items: center; gap: 5px;
  font-size: 14px; font-weight: 600; color: #E86A10;
  text-decoration: none; transition: color 0.15s;
}
.uv-back-link:hover { color: #cf5e0d; }
.uv-breadcrumb-sep { color: var(--dk-text-faint, #c8d0db); font-size: 14px; }
.uv-breadcrumb-cur { font-size: 14px; color: var(--dk-text-muted, #8a94a6); font-weight: 500; }

/* ─── Grid ─── */
.uv-grid {
  display: grid;
  grid-template-columns: 1fr 340px;
  gap: 20px;
  align-items: start;
}
.uv-col-main { min-width: 0; }
.uv-col-side { display: flex; flex-direction: column; gap: 20px; }

@media (max-width: 900px) {
  .uv-grid { grid-template-columns: 1fr; }
}
</style>
